var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedTxn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C14.12 8 12.38 8.66 11 9.76C9.16 11.22 8 13.48 8 16C8 17.5 8.42 18.92 9.16 20.12C10.54 22.44 13.08 24 16 24C18.02 24 19.86 23.26 21.26 22C21.88 21.48 22.42 20.84 22.84 20.12C23.58 18.92 24 17.5 24 16C24 11.58 20.42 8 16 8ZM12.84 14.92C12.26 14.34 12.26 13.38 12.84 12.8C13.44 12.22 14.38 12.22 14.98 12.8L16.02 13.86L17.02 12.84C17.62 12.26 18.56 12.26 19.16 12.84C19.74 13.44 19.74 14.38 19.16 14.98L18.14 15.98L19.2 17.02C19.78 17.62 19.78 18.56 19.2 19.16C18.9 19.44 18.52 19.58 18.14 19.58C17.76 19.58 17.38 19.44 17.08 19.16L16.02 18.1L14.92 19.2C14.62 19.5 14.24 19.64 13.86 19.64C13.48 19.64 13.1 19.5 12.8 19.2C12.22 18.62 12.22 17.66 12.8 17.08L13.9 15.98L12.84 14.92Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTxn);
export default __webpack_public_path__ + "static/media/failed-txn.7e721d30f3147a34054ed913610eed7b.svg";
export { ForwardRef as ReactComponent };